import React from 'react';
import {observer} from 'mobx-react';
import Store, {AnalyticsTab} from '../../stores/store';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {important} from 'csx';
import {classes, stylesheet} from 'typestyle';
import {I18n} from '../../i18n/i18n';
import {ChannelStatus} from '../../stores/ChannelStore';
import {BlackColor, WhiteColor, GreyColor} from '../../styles/colors';

interface CurrencyOptionMenuProps {
    store: Store;
}

@observer
export class CurrencyOptionMenu extends React.Component<CurrencyOptionMenuProps> {
    private onTargetCurrencyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        this.props.store.currencyStore.targetCurrency = e.currentTarget.value;
    };

    public render() {
        const {
            channelStore: {getAllChannelCurrencies, channelLoadingStatus},
            currencyStore: {targetCurrency},
            activeAnalyticsTab,
        } = this.props.store;
        if (channelLoadingStatus === ChannelStatus.Loading || activeAnalyticsTab === AnalyticsTab.Dashboard) {
            return null;
        }

        const availableCurrencies = getAllChannelCurrencies();

        const {disabled: selectDisabled, className: selectClassName} =
            this.props.store.activeAnalyticsTab === AnalyticsTab.Dashboard
                ? {disabled: true, className: currencyCss.selectDisabled}
                : {disabled: false, className: ''};

        return (
            <div className={currencyCss.currencyTab}>
                <div className={currencyCss.currencyTabContainer}>
                    <div className={currencyCss.currencySelectorContainer}>
                        <div className={currencyCss.currencySelectorTitle}>
                            <div className={currencyCss.diagramIconContainer}>
                                <FontAwesomeIcon icon="chart-line" className={currencyCss.diagramIcon} />
                            </div>
                            <div className={currencyCss.targetCurrencyLabelContainer}>
                                <I18n i18nKey="currency.targetCurrency" />
                            </div>
                        </div>
                        <select
                            disabled={selectDisabled}
                            value={targetCurrency}
                            onChange={this.onTargetCurrencyChange}
                            className={classes(selectClassName, currencyCss.currencySelect)}>
                            {availableCurrencies.map((currency) => (
                                <option style={{color: BlackColor}} key={currency} value={currency}>
                                    {currency}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}

const currencyCss = stylesheet({
    diagramIcon: {
        marginRight: 5,
        height: 15,
        width: important('15px'),
    },
    targetCurrencyLabelContainer: {
        display: 'inline-block',
        verticalAlign: 'middle',
    },
    diagramIconContainer: {
        display: 'inline-block',
        verticalAlign: 'top',
        height: 15,
    },
    currencySelect: {
        marginTop: -5,
        backgroundColor: 'transparent',
        color: WhiteColor,
        border: 'none',
        width: '100%',
    },
    selectDisabled: {
        color: GreyColor,
    },
    currencySelectorTitle: {
        color: WhiteColor,
        verticalAlign: 'top',
        fontSize: 10,
    },
    currencySelectorContainer: {
        flex: 1,
        marginRight: 5,
    },
    currencyTabContainer: {
        display: 'flex',
        flexDirection: 'row',
    },
    currencyTab: {
        display: 'inline-block',
        verticalAlign: 'top',
        border: '1px solid ' + WhiteColor,
        height: 40,
        marginTop: 2,
        borderRadius: 2,
        paddingLeft: 5,
        paddingRight: 5,
        borderBottom: 'none',
    },
});



// WEBPACK FOOTER //
// ./src/views/Table/CurrencyOptionMenu.tsx